exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* --------------- Offer modal --------------- */\n\n.offer-modal h2 {\n\tfont-size: 18px;\n\tmargin: 0 0 10px 0;\n}\n.offer-modal p.offer-info {\n\tmargin: 30px 0 30px 0;\n\ttext-align: center;\n}\n.offer-modal md-card {\n\tmargin: 0;\n\toverflow: hidden;\n}\n.offer-modal md-card.expectation {\n\tmargin: 0 0 20px 0;\n\toverflow: hidden;\n}\n.offer-modal .mat-raised-button {\n\twidth: 100%;\n\tfloat: right;\n}\n@media only screen and (min-width: 350px) {\n\t.offer-modal .mat-raised-button {\n\t\twidth: auto;\n\t}\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/offer-modal/offer-modal.component.css
// module id = ./src/app/shared/components/offer-modal/offer-modal.component.css
// module chunks = 1